import React from 'react';
import classNames from 'classnames';
import InputFields from './InputFields/InputFields';
import style from './EditForm.module.scss';

interface ICreationForm {
	isVisible: boolean;
}

const EditForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="EditForm">
			<InputFields />
		</div>
	);
};

export default EditForm;
